// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter--hidden{opacity:0;pointer-events:none}.change-opacity{transition:all .2s linear}.visible-true{visibility:hidden;position:absolute;top:-1000px}.bg-color-row{background-color:#eaebf6}.verde_eb.v-btn.v-btn--disabled{opacity:.4}.mdi-content-copy,.mdi-download,.verde_eb.v-btn.v-btn--disabled .mdi-printer{color:#fff!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
